import { ChannelType, ConnectChannelModalSource } from 'common/core/constants/ChannelType'
import { useConnectChannelModal } from 'common/core/hooks/useConnectChannelModal'
import { IgExploreModeAnalytics } from 'common/core/lib/igExploreModeAnalytics'

export const useExploreModeConnectChannel = () => {
  const connectChannelModal = useConnectChannelModal()

  return {
    close: connectChannelModal.close,
    // source is required because every explore-mode call site must identify its trigger
    open: (channels: ChannelType[], source: ConnectChannelModalSource) => {
      IgExploreModeAnalytics.logChannelConnectionPopupOpen(source)
      connectChannelModal.open(channels, source)
    },
  }
}
